import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Avatar,
  Card,
  CardContent,
  Grid,
  Chip,
  Tooltip,
  Stack,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  RadioGroup,
  Radio,
  Tabs,
  Tab,
  CardActions,
  IconButton,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { green, grey } from "@mui/material/colors";
import { useParams } from "react-router-dom";
import P2PNavbar from "./P2PNavbar";
import {
  P2PWEBSERVICE,
  WEBSERVICE,
  showToast,
  tabsStyle,
} from "../../CoreDataService";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTheme } from "@mui/material/styles";
import p2pWebSocketService from "./p2pWebSocketService";
// import EditSquareIcon from '@mui/icons-material/EditSquare';
import EditIcon from "@mui/icons-material/Edit";
import { useChat } from "../../Services/ChatService";
import axios from "axios";
import { use } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
// import { ThumbUp, ThumbDown } from "@mui/icons-material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { ButtonGroup } from "react-bootstrap";
import CustomCircleCheck from "../../Common/CircleCheck";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const P2PMyProfile = () => {
  const {
    message,
    onlineUsers,
    onlineBroker,
    p2pmessage,
    p2pmessageCustomer,
    p2pmessageCustomerAppeal,
    makeUserOnline,
    sendMessageToUser,
  } = useChat(); // Access state and methods

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange", // Ensures real-time validation updates
    defaultValues: {
      accountHolder: "",
      ibanNumber: "",
      bankName: "",
      accountType: "",
      bankAddress: "",
      codeType: "",
      additionalCode: "",
    },
  });

  const theme = useTheme();
  const themecolor = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [holdingInUsd, setHoldingInUsd] = useState(null);
  const [allBuyAds, setAllBuyAds] = useState([]);
  const [allSellAds, setAllSellAds] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [poitiveFeedPercent, setPoitiveFeedPercent] = useState(0);
  const [bankTransferPaymentMethodList, setBankTransferPaymentMethodList] =
    useState([]);
  const [walletServicePaymentMethodList, setWalletServicePaymentMethodList] =
    useState([]);
  const navigate = useNavigate();

  const [orderType, setOrderType] = useState("BUY");
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState("All Currencies");
  const [paymentMethod, setPaymentMethod] = useState("All Payment Methods");
  const [region, setRegion] = useState("All Regions");
  const [regionList, setRegionList] = useState([]);

  const [sortOrder, setSortOrder] = useState("0");
  const [selectedFiatCurrency, setSelectedFiatCurrency] = useState("USDT");

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const websocketRef = useRef(null);
  const [ads, setAds] = useState([]);
  const [buyOrders, setBuyOrders] = useState([]);

  const [allCurrencies, setAllCurrencies] = useState([]);
  const [visibleCurrencies, setVisibleCurrencies] = useState(
    allCurrencies.slice(0, 6)
  );
  const [hiddenCurrencies, setHiddenCurrencies] = useState(
    allCurrencies.slice(6)
  );
  const [allFiatList, setAllFiatList] = useState([]);
  const [recordCount, setRecordCount] = useState(null);
  const [completionRate, setCompletionRate] = useState(null);
  const [paymentTimeLimit, setPaymentTimeLimit] = useState(null);
  const [minOrderLimit, setMinOrderLimit] = useState(null);
  const [maxOrderLimit, setMaxOrderLimit] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [price, setPrice] = useState(null);
  const [fiat, setFiat] = useState("");
  const [crypto, setCrypto] = useState("");
  const [paymentProviderName, setPaymentProviderName] = useState([]);
  const [availableAmount, setAvailableAmount] = useState(null);
  const [adId, setAdId] = useState(null);
  const [counterPartyUuid, setCounterPartyUuid] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [sellAmount, setSellAmount] = useState(null);
  const [onlineStatus, setOnlineStatus] = useState(null);
  const [profilePic, setProfilePic] = useState("");
  const [profileImageLink, setProfileImageLink] = useState("");
  const [firstLetter, setFirstLetter] = useState("");
  const [
    currentSelectedBankPaymentMethod,
    setCurrentSelectedBankPaymentMethod,
  ] = useState([]);
  const [selectedBankPaymentMethod, setSelectedBankPaymentMethod] = useState(
    []
  );
  const [
    currentSelectedWalletPaymentMethod,
    setCurrentSelectedWalletPaymentMethod,
  ] = useState([]);
  const [selectedWalletPaymentMethod, setSelectedWalletPaymentMethod] =
    useState([]);
  const [buyDialogOpen, setBuyDialogOpen] = useState(false);
  const [sellDialogOpen, setSellDialogOpen] = useState(false);
  const [walletAvailableBalance, setWalletAvailableBalance] = useState(0);
  const [modalPrice, setModalPrice] = useState(null);
  const [modalRemainingAmount, setModalRemainingAmount] = useState(null);
  const [payAmount, setPayAmount] = useState(null);
  const [receiveAmount, setReceiveAmount] = useState(null);
  const [paymentEditModal, setPaymentEditModal] = useState(false);
  const [formValues, setFormValues] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [pmDetailsId, setPmDetailsId] = useState(null);
  const [editPaymentMethod, setEditPaymentMethod] = useState("");

  const [accountHolderNameEdit, setAccountHolderNameEdit] = useState("");
  const [paymentProviderNameEdit, setPaymentProviderNameEdit] = useState("");
  const [phoneNumberEdit, setPhoneNumberEdit] = useState("");
  const [walletIdEdit, setWalletIdEdit] = useState("");
  const [emailIdEdit, setEmailIdEdit] = useState("");

  const [accountNumberEdit, setAccountNumberEdit] = useState("");
  const [accountTypeEdit, setAccountTypeEdit] = useState("");
  const [identificationTypeEdit, setIdentificationTypeEdit] = useState("");
  const [routingNumberEdit, setRoutingNumberEdit] = useState("");
  const [bankNameEdit, setBankNameEdit] = useState("");
  const [bankAddressEdit, setBankAddressEdit] = useState("");

  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [bankIdentificationTypeOptions, setBankIdentificationTypeOptions] =
    useState([]);
  const [selectedAccountType, setSelectedAccountType] = useState("");
  const [selectedCodeType, setSelectedCodeType] = useState("");
  const [adsloading, setAdsloading] = useState("");
  const [blockModalOpen, setBlockModalOpen] = useState(false);

  const [allBlockReason, setAllBlockReason] = useState([]);
  const [otherReasonStatus, setOtherReasonStatus] = useState(false);
  const [customReason, setCustomReason] = useState("");

  const [reportList, setReportList] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [reportEmail, setReportEmail] = useState("");
  const [reportDesc, setReportDesc] = useState("");
  const [files, setFiles] = useState([]);
  const [paymentCreateModal, setPaymentCreateModal] = useState(false);
  const [createPaymentMethod, setCreatePaymentMethod] = useState("");

  const [isOnline, setIsOnline] = useState(false);
  // Tab component for displaying feedback and payment methods
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedChildTab, setSelectedChildTab] = useState(0);

  const [paymentMethodsCount, setPaymentMethodsCount] = useState(3); // Example count
  const { userInfo, brokerBasicInfo } = useSelector((state) => state);

  const [profileName, setProfileName] = useState("John");

  const [paymentProviderNameCreate, setPaymentProviderNameCreate] =
    useState("");
  const [phoneNumberCreate, setPhoneNumberCreate] = useState("");
  const [walletIdCreate, setWalletIdCreate] = useState("");
  const [emailIdCreate, setEmailIdCreate] = useState("");

  const [allFeedback, setAllFeedback] = useState([]);
  const [positiveFeedback, setPositiveFeedback] = useState([]);
  const [negativeFeedback, setNegativeFeedback] = useState([]);

  const [selectedFeedbackChildTab, setSelectedFeedbackChildTab] = useState(0);
  const [selectedFollowChildTab, setSelectedFollowChildTab] = useState(0);
  const [isFollowing, setIsFollowing] = useState(false);

  const [allBlockedUsers, setAllBlockedUsers] = useState([]);
  const [allMyFollowersUsers, setAllMyFollowersUsers] = useState([]);
  const [allMyFollowingUsers, setAllMyFollowingUsers] = useState([]);
  const [openNicknameModal, setOpenNicknameModal] = useState(false);
  const [nickname, setNickname] = useState();
  const [newNickname, setNewNickname] = useState(nickname);

  const handleTabChange = (event, newTab) => {
    setSelectedTab(newTab);
  };

  const handleChildTabChange = (event, newTab) => {
    setSelectedChildTab(newTab);
  };

  const handleFeedbackChildTabChange = (event, newTab) => {
    setSelectedFeedbackChildTab(newTab);
  };
  const handleFollowChildTabChange = (event, newTab) => {
    setSelectedFollowChildTab(newTab);
  };

  const openPaymentMethodModal = () => {
    console.log("Open Payment Method Modal");
  };

  const [userInfoApi, setUserInfo] = useState({
    nickname: "",
    profileName: "",
    profilePic: "",
    profileImageLink: "",
    firstLetter: "",
    userId: "",
    emailStatus: false,
    mobileStatus: false,
    addressStatus: false,
    kycStatus: false,
    followStatus: false,
    blockStatus: false,
  });

  useEffect(() => {
    fetchUserInfo();

    getAllPaymentMethodByUser();
    getAllBlockReason();
    getFeedback();
    getBlockedUsers();
    getmyFollowers();
    getmyFollowing();
  }, []);

  useEffect(() => {
    var foundValue = onlineUsers.filter(
      (obj) => obj.userId === localStorage.getItem("uuid")
    );
    if (foundValue.length > 0) {
      setIsOnline(true);
    } else {
      setIsOnline(false);
    }
  }, [onlineUsers]);

  const fetchUserInfo = async () => {
    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const res = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/getP2PUserDetails`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const details = res.data.userDetails[0];
      setUserDetails(details);

      const nameToUse = details.nickName || details.name;
      const imageLink = details.profilePic
        ? `https://paybito-profilepic-usa.s3.us-west-1.amazonaws.com/${localStorage.getItem(
            "uuid"
          )}/${details.profilePic}`
        : "";

      const feedbackPercent =
        details.negativeFeedback === 0 && details.positiveFeedback > 0
          ? 100
          : details.negativeFeedback === 0 && details.positiveFeedback === 0
          ? 0
          : (details.positiveFeedback * 100) /
            (details.positiveFeedback + details.negativeFeedback);

      setPoitiveFeedPercent(feedbackPercent);
      setUserInfo({
        nickname: nameToUse,
        profileName: details.profileName,
        profilePic: details.profilePic,
        profileImageLink: imageLink,
        firstLetter: nameToUse.charAt(0),
        userId: details.userId,
        emailStatus: !!details.emailId,
        mobileStatus: !!details.mobileNo,
        addressStatus: !!details.usersAddress,
        kycStatus:
          details.bankDetailsStatus === 2 && details.userDocsStatus === 1,
        followStatus: details.followingStatus !== 0,
        blockStatus: details.blockedStatus !== 0,
      });
    } catch (error) {
      console.error("Error fetching user info", error);
    } finally {
      setLoading(false);
    }
  };

  const getAllPaymentMethodByUser = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const accessToken = localStorage.getItem("access_token");

      const response = await axios.post(
        `${P2PWEBSERVICE}/getAllPaymentMethodByUser`,
        { uuid },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const { error, error_msg, paymentDetails } = response.data;

      if (error?.error_data === 0 && Array.isArray(paymentDetails)) {
        const bankMethods = [];
        const walletMethods = [];

        paymentDetails.forEach((method) => {
          if (method.paymentMethodName === "BANK TRANSFER") {
            let identificationType = "";
            let identificationNumber = "";

            if (method.ifscCode) {
              identificationType = "IFSC CODE";
              identificationNumber = method.ifscCode;
            } else if (method.swiftCode) {
              identificationType = "SWIFT CODE";
              identificationNumber = method.swiftCode;
            } else if (method.routingNo) {
              identificationType = "ROUTING NO";
              identificationNumber = method.routingNo;
            }

            bankMethods.push({
              accountHolderName: method.profileName,
              bankName: method.bankName,
              pmDetailsId: method.pmDetailsId,
              accountNo: method.accountNo,
              accountType: method.accountType,
              identificationType,
              identificationNumber,
              bankAddress: method.bankAddress,
            });
          } else {
            walletMethods.push({
              paymentProviderName: method.paymentProviderName,
              walletId: method.vpa,
              pmDetailsId: method.pmDetailsId,
              email_id: method.emailId,
              phone_number: method.mobileNo,
              profileName: method.profileName,
            });
          }
        });

        console.log(
          "BankTransferPaymentMethodList",
          bankTransferPaymentMethodList
        );
        console.log(
          "walletTransferPaymentMethodList",
          walletServicePaymentMethodList
        );

        setBankTransferPaymentMethodList(bankMethods);
        setWalletServicePaymentMethodList(walletMethods);
      } else {
        showToast("error", error_msg || "Failed to fetch payment methods");
        setBankTransferPaymentMethodList([]);
        setWalletServicePaymentMethodList([]);
      }
    } catch (error) {
      showToast("error", "Something went wrong while fetching payment methods");
      setBankTransferPaymentMethodList([]);
      setWalletServicePaymentMethodList([]);
    }
  };

  const getAllRegion = async () => {
    try {
      const response = await axios.get(
        WEBSERVICE + `crypto/banking/p2p/getAllRegions`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      let regions = response.data.regions || [];

      setRegionList(regions);
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };

  const addBankPaymentMethod = (i) => {
    const existingIndex = currentSelectedBankPaymentMethod.findIndex(
      (item) => item.currentIndex === i
    );
    const bankDetails = bankTransferPaymentMethodList[i];

    console.log("bankDetails", bankDetails);

    if (existingIndex !== -1) {
      // Deselect
      setCurrentSelectedBankPaymentMethod((prev) =>
        prev.filter((item) => item.currentIndex !== i)
      );
      setSelectedBankPaymentMethod((prev) =>
        prev.filter((item) => item.pmDetailsId !== bankDetails.pmDetailsId)
      );
    } else {
      // Select
      setCurrentSelectedBankPaymentMethod((prev) => [
        ...prev,
        { currentIndex: i },
      ]);
      setSelectedBankPaymentMethod((prev) => [
        ...prev,
        {
          pmDetailsId: bankDetails.pmDetailsId,
          bankName: bankDetails.bankName,
        },
      ]);
    }
  };

  const addWalletPaymentMethod = (i) => {
    const existingIndex = currentSelectedWalletPaymentMethod.findIndex(
      (item) => item.currentIndex === i
    );
    const walletDetails = walletServicePaymentMethodList[i];

    if (existingIndex !== -1) {
      // Deselect
      setCurrentSelectedWalletPaymentMethod((prev) =>
        prev.filter((item) => item.currentIndex !== i)
      );
      setSelectedWalletPaymentMethod((prev) =>
        prev.filter((item) => item.pmDetailsId !== walletDetails.pmDetailsId)
      );
    } else {
      // Select
      setCurrentSelectedWalletPaymentMethod((prev) => [
        ...prev,
        { currentIndex: i },
      ]);
      setSelectedWalletPaymentMethod((prev) => [
        ...prev,
        {
          pmDetailsId: walletDetails.pmDetailsId,
          paymentProviderName: walletDetails.paymentProviderName,
        },
      ]);
    }
  };

  const handleOpenEditPaymentModal = (pmDetailsId, index, service) => {
    if (service === "wallet_services") {
      setAccountHolderNameEdit(
        walletServicePaymentMethodList[index].profileName
      );
      setPaymentProviderNameEdit(
        walletServicePaymentMethodList[index].paymentProviderName
      );
      setPhoneNumberEdit(walletServicePaymentMethodList[index].phone_number);
      setWalletIdEdit(walletServicePaymentMethodList[index].walletId);
      setEmailIdEdit(walletServicePaymentMethodList[index].email_id);
      setEditPaymentMethod("Wallet Services");
    } else {
      setAccountHolderNameEdit(
        bankTransferPaymentMethodList[index].accountHolderName
      );
      setAccountNumberEdit(bankTransferPaymentMethodList[index].accountNo);
      setAccountTypeEdit(bankTransferPaymentMethodList[index].accountType);
      setIdentificationTypeEdit(
        bankTransferPaymentMethodList[index].identificationType
      );
      setRoutingNumberEdit(
        bankTransferPaymentMethodList[index].identificationNumber
      );
      setBankNameEdit(bankTransferPaymentMethodList[index].bankName);
      setBankAddressEdit(bankTransferPaymentMethodList[index].bankAddress);

      setValue(
        "accountHolder",
        bankTransferPaymentMethodList[index].accountHolderName || ""
      );
      setValue(
        "ibanNumber",
        bankTransferPaymentMethodList[index].accountNo || ""
      );

      setValue("bankName", bankTransferPaymentMethodList[index].bankName || "");
      setValue(
        "accountType",
        bankTransferPaymentMethodList[index].accountType || "Personal Savings"
      );
      setSelectedAccountType(bankTransferPaymentMethodList[index].accountType);
      setValue(
        "bankAddress",
        bankTransferPaymentMethodList[index].bankAddress || ""
      );

      setValue(
        "codeType",
        bankTransferPaymentMethodList[index].identificationType
      );
      setSelectedCodeType(
        bankTransferPaymentMethodList[index].identificationType
      );
      setValue(
        "additionalCode",
        bankTransferPaymentMethodList[index].identificationNumber
      );
      console.log(
        "additionalCode",
        bankTransferPaymentMethodList[index].identificationNumber
      );

      setEditPaymentMethod("Bank Transfer");
    }

    setPmDetailsId(pmDetailsId);
    setPaymentEditModal(true); // Show the modal
  };

  const validateBankCode = (code) => {
    if (!code) return "Required";
    const type = watch("codeType");
    let reg;
    if (type === "ROUTING NO") {
      reg = /^\d{9}$/gm;
      return reg.test(code)
        ? true
        : "Invalid Routing Number (9 digits required)";
    } else if (type === "SWIFT CODE") {
      reg = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/gm;
      return reg.test(code) ? true : "Invalid SWIFT Code";
    } else if (type === "IFSC CODE") {
      reg = /^[A-Z]{4}0[A-Z0-9]{6}$/gm;
      return reg.test(code) ? true : "Invalid IFSC Code";
    }
    return "Invalid Code";
  };

  const allowPhoneNumber = (e) => {
    const key = e.key;
    const value = e.target.value;

    // allow control keys
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }

    // allow '+' only if it's the first character
    if (key === "+" && value.length === 0) {
      return;
    }

    // allow only digits
    const regex = /^[0-9]$/;
    if (!regex.test(key)) {
      e.preventDefault(); // block anything that's not a digit or allowed +
    }
  };

  const allowOnlyAlphabets = (e) => {
    const key = e.key;
    // allow backspace, tab, arrows, delete
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    // allow letters and space
    const regex = /^[a-zA-Z\s]$/;
    if (!regex.test(key)) {
      e.preventDefault(); // block invalid char
    }
  };
  const handlePasteOnlyAlpha = (e) => {
    const pasteData = e.clipboardData.getData("text");
    const regex = /^[a-zA-Z\s]$/;

    if (!regex.test(pasteData)) {
      e.preventDefault(); // block invalid pasted content
    }
  };
  const allowOnlyAlphaNum = (e) => {
    const key = e.key;
    // allow backspace, tab, arrows, delete
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    // allow letters and space
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (!regex.test(key)) {
      e.preventDefault(); // block invalid char
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text");
    const regex = /^[a-zA-Z0-9 ]*$/;

    if (!regex.test(pasteData)) {
      e.preventDefault(); // block invalid pasted content
    }
  };

  const allowEmail = (e) => {
    const key = e.key;

    // allow control keys
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }

    // regex: letters, numbers, @ . _ -
    const regex = /^[a-zA-Z0-9@._-]$/;
    if (!regex.test(key)) {
      e.preventDefault(); // block anything not allowed
    }
  };

  const updateBankDetails = async () => {
    const formValues = watch();
    console.log("formValues.accountType", formValues);

    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "UPDATE",
      transferType: 2,
      paymentMethodName: "BANK TRANSFER",
      profileName: formValues.accountHolder,
      accountNo: formValues.ibanNumber,
      accountType: formValues.accountType,
      bankName: formValues.bankName,
      bankAddress: formValues.bankAddress,
      pmDetailsId: pmDetailsId,
    };

    switch (formValues.codeType) {
      case "ROUTING NO":
        payload.routingNo = formValues.additionalCode;
        break;
      case "IFSC CODE":
        payload.ifscCode = formValues.additionalCode;
        break;
      case "SWIFT CODE":
        payload.swiftCode = formValues.additionalCode;
        break;
      default:
        break;
    }
    // console.log('payload',payload);

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");

        setTimeout(() => {
          // Close modal and reset state
          setPaymentEditModal(false);
          setPmDetailsId("");
          setAccountHolderNameEdit("");
          setAccountNumberEdit("");
          setAccountTypeEdit("");
          setIdentificationTypeEdit("");
          setRoutingNumberEdit("");
          setBankNameEdit("");
          setBankAddressEdit("");

          getAllPaymentMethodByUser(); // Refresh list
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "An error occurred while updating the payment method");
      console.error("Update error:", error);
    }
  };

  const updateWalletDetails = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "UPDATE",
      transferType: 1,
      paymentMethodName: "WALLET SERVICE",
      profileName: accountHolderNameEdit,
      mobileNo: phoneNumberEdit,
      vpa: walletIdEdit,
      emailId: emailIdEdit,
      paymentProviderName: paymentProviderNameEdit,
      pmDetailsId: pmDetailsId,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");

        setTimeout(() => {
          // Close modal and reset form
          setPaymentEditModal(false); // assumes you're using state to control modal visibility
          setPmDetailsId("");
          setPaymentProviderNameEdit("");
          setPhoneNumberEdit("");
          setWalletIdEdit("");
          setEmailIdEdit("");
          setAccountHolderNameEdit("");

          getAllPaymentMethodByUser(); // Refresh list
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "Failed to update payment method");
      console.error("Error updating wallet details:", error);
    }
  };

  const createWalletDetails = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "INSERT",
      transferType: 1,
      paymentMethodName: "WALLET SERVICE",
      profileName: userInfo.userResult.firstName + userInfo.userResult.lastName,
      mobileNo: phoneNumberCreate,
      vpa: walletIdCreate,
      emailId: emailIdCreate,
      paymentProviderName: paymentProviderNameCreate,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/addUserPaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");
        setPaymentCreateModal(false);
        setTimeout(() => {
          // Close modal and reset form
          setPaymentEditModal(false); // assumes you're using state to control modal visibility
          setPmDetailsId("");
          setPaymentProviderNameCreate("");
          setPhoneNumberCreate("");
          setWalletIdCreate("");
          setEmailIdCreate("");

          getAllPaymentMethodByUser(); // Refresh list
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "Failed to update payment method");
      console.error("Error updating wallet details:", error);
    }
  };

  const followUnfollowUsers = async (e) => {
    const jsonObj = {
      followingUuid: localStorage.getItem("uuid"),
      followerUuid: localStorage.getItem("uuid"),
      followingStatus: e,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/addFollowers`,
        jsonObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast("success", response.data.error.error_msg);

        fetchUserInfo();
      } else {
        showToast("error", response.data.error.error_msg);
        fetchUserInfo();
      }
    } catch (error) {
      showToast("error", "Something went wrong. Please try again.");
      console.error(error);
    }
  };

  const blockUnblockFuncCall = async (status) => {
    if (status == 0) {
      setBlockModalOpen(true);
    } else {
      blockUnblockApiCall(0, 0);
    }
  };

  const blockUnblockApiCall = async (blockStatus, reasonId) => {
    const jsonObj = {
      blockBy: localStorage.getItem("uuid"),
      blockedUser: localStorage.getItem("uuid"),
      blockStatus: blockStatus,
      reasonId: reasonId,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/blockP2PUser`,
        jsonObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast(
          "success",
          `${!userInfo.blockStatus ? "Block" : "Unblock"} Successfully`
        );
        fetchUserInfo();
      } else {
        showToast("error", response.data.error.error_msg);
        fetchUserInfo();
      }
    } catch (error) {
      showToast("error", "Something went wrong while unblocking");
      console.error(error);
    }
  };

  const getAllBlockReason = async () => {
    try {
      const res = await axios.get(
        `${WEBSERVICE}crypto/banking/p2p/getBlockReasons`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setAllBlockReason(res.data.blockDetails);
    } catch (err) {
      showToast("error", "Failed to fetch block reasons");
    }
  };

  const handlePaymentEditDialogClose = () => {
    setPaymentEditModal(false);
  };

  const deletePaymentMethod = async (pmDetailsId, type) => {
    let pm = "";
    let trtype = null;

    if (type === "wallet_service") {
      pm = "WALLET SERVICE";
      trtype = 1;
    } else if (type === "bank_transfer") {
      pm = "BANK TRANSFER";
      trtype = 2;
    }

    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      action: "DELETE",
      pmDetailsId: pmDetailsId,
      paymentMethodName: pm,
      transferType: trtype,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const apiMessage = response.data.error_data;
      const apiMessageText = response.data.error_msg;

      if (apiMessage === 0) {
        showToast("success", "Payment Method deleted successfully");
        setTimeout(() => {
          getAllPaymentMethodByUser();
        }, 2000);
      } else {
        showToast("error", apiMessageText);
      }
    } catch (error) {
      console.error("Error deleting payment method:", error);
      showToast(
        "error",
        "An error occurred while deleting the payment method."
      );
    }
  };

  const createBankDetails = async () => {
    // if (!data.accountHolder || !data.bankName || !data.ibanNumber || !data.additionalCode || !data.bankAddress || !data.accountType) {
    //   showToast("warning", "You have not made any changes");
    //   return;
    // }
    const formValues = watch();

    if (
      formValues.bankName == "" ||
      formValues.ibanNumber == "" ||
      formValues.bankAddress == "" ||
      formValues.accountType == ""
    ) {
      showToast("warning", "Please fill all the fields");
    } else {
      console.log("formValues.accountType", formValues.accountType);

      const updateBankObj = {
        uuid: localStorage.getItem("uuid"),
        action: "INSERT",
        transferType: 2,
        paymentMethodName: "BANK TRANSFER",
        profileName: formValues.accountHolder,
        bank_name: formValues.bankName,
        accountNo: formValues.ibanNumber,
        bankAddress: formValues.bankAddress,
        accountType: formValues.accountType,
      };

      switch (formValues.codeType) {
        case "ROUTING NO":
          updateBankObj["routing_no"] = formValues.additionalCode;
          break;
        case "IFSC CODE":
          updateBankObj["ifscCode"] = formValues.additionalCode;
          break;
        case "SWIFT CODE":
          updateBankObj["swiftCode"] = formValues.additionalCode;
          break;
        case "IBAN NO":
          updateBankObj["ibanNo"] = formValues.additionalCode;
          break;
        default:
          break;
      }

      try {
        const response = await axios.post(
          P2PWEBSERVICE + "/addUserPaymentMethod",
          JSON.stringify(updateBankObj),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        );

        if (response.data.error_data !== 0) {
          showToast("error", response.data.error_msg);
          setPaymentCreateModal(false);
        } else {
          showToast("success", "Payment Method added sucessfully");
          setPaymentCreateModal(false);
          setPaymentCreateModal(false);

          getAllPaymentMethodByUser();
        }
      } catch (error) {}
    }
  };

  const handleSelectBank = (val) => {
    setCreatePaymentMethod(val);
    setSelectedAccountType(val);
  };

  const handleUnBlockUsers = async (blockedUser, blockedBy) => {
    try {
      const token = localStorage.getItem("access_token");

      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/blockP2PUser`,
        {
          blockBy: localStorage.getItem("uuid"),
          blockedUser: blockedUser,
          blockStatus: 0,
          reasonId: 0,
        }, // directly sending object instead of JSON.stringify
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      if (response.data.error.error_data == 0) {
        showToast(
          "success",
          `${!userInfo.blockStatus ? "Block" : "Unblock"} Successfully`
        );
        getBlockedUsers();
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  const handleUnFollowUsers = async (following, blockedBy) => {
    try {
      const token = localStorage.getItem("access_token");

      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/addFollowers`,
        {
          followerUuid: localStorage.getItem("uuid"),
          followingUuid: following,
          followingStatus: 0,
        }, // directly sending object instead of JSON.stringify
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      if (response.data.error.error_data == 0) {
        showToast("success", "Unblocked Successfully");
        getmyFollowers();
        getmyFollowing();
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  const getBlockedUsers = async () => {
    try {
      const token = localStorage.getItem("access_token");

      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/getBlockedP2PUsers`,
        { blockBy: localStorage.getItem("uuid") }, // directly sending object instead of JSON.stringify
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const blockedData = response.data.blockDetails || [];

      const blockedDataNew = blockedData.filter((item) => item.isBlocked === 1);

      setAllBlockedUsers(blockedDataNew);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  const getmyFollowers = async () => {
    try {
      const token = localStorage.getItem("access_token");

      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/getFollowers`,
        {
          followerUuid: localStorage.getItem("uuid"),
          followFlag: 0,
        }, // directly sending object instead of JSON.stringify
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const myFollwers = response.data.followDetails || [];

      setAllMyFollowersUsers(myFollwers);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  const getmyFollowing = async () => {
    try {
      const token = localStorage.getItem("access_token");

      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/getFollowers`,
        {
          followerUuid: localStorage.getItem("uuid"),
          followFlag: 1,
        }, // directly sending object instead of JSON.stringify
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const myFollowing = response.data.followDetails || [];

      setAllMyFollowingUsers(myFollowing);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  const getFeedback = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const token = localStorage.getItem("access_token");

      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/getFeedback`,
        { uuid }, // directly sending object instead of JSON.stringify
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const feedbackData = response.data.feedbackResponse || [];
      setAllFeedback(feedbackData);

      const positive = feedbackData.filter((item) => item.feedbackStatus === 1);
      const negative = feedbackData.filter((item) => item.feedbackStatus !== 1);

      setPositiveFeedback(positive);
      setNegativeFeedback(negative);

      console.log("Positive Feedback:", positive);
      console.log("Negative Feedback:", negative);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  const handleClickOpen = () => {
    setNewNickname(nickname); // reset input field when dialog opens
    setOpenNicknameModal(true);
  };

  const handleClose = () => setOpenNicknameModal(false);

  const handleSave = async () => {
    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/addUserNickname`,
        {
          uuid: localStorage.getItem("uuid"),
          newNickName: userInfoApi.nickname,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast("success", response.data.error.error_msg);
        handleClose();
      } else {
        showToast("error", response.data.error.error_msg);
        handleClose();
      }
    } catch (error) {
      console.error("Nickname update failed", error);
      showToast("error", "Something went wrong!");
      handleClose();
    }
  };

  // ── Style objects ──────────────────────────────────────────────────────────

  const pageWrapper = {
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 3 },
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    minHeight: "calc(100vh - 64px)",
  };

  const mainCard = {
    backgroundColor: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid rgba(125,125,125,0.15)",
    overflow: "hidden",
    mb: 3,
  };

  const profileHeader = {
    p: { xs: 2, md: 3 },
    backgroundColor: "var(--body-color-less2)",
    borderBottom: "1px solid rgba(125,125,125,0.15)",
  };

  const tabsWrap = {
    borderBottom: "1px solid rgba(125,125,125,0.15)",
    backgroundColor: "var(--body-color-less2)",
  };

  const tabsSx = {
    "& .MuiTabs-indicator": { backgroundColor: btncolor },
    "& .MuiTab-root": {
      color: "var(--text-color)",
      opacity: 0.65,
      fontWeight: 600,
      fontSize: "0.85rem",
      textTransform: "none",
      "&.Mui-selected": { color: btncolor, opacity: 1 },
    },
  };

  const modernTableContainer = { borderRadius: 0, border: "none", overflow: "auto" };

  const tableHeadCell = {
    fontSize: "0.72rem",
    fontWeight: 700,
    color: "var(--text-color)",
    opacity: 0.6,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    py: 1.5,
    px: 2,
    borderBottom: "1px solid rgba(125,125,125,0.15)",
    backgroundColor: "var(--body-color-less2)",
  };

  const tableBodyRow = {
    "&:hover": { backgroundColor: "rgba(125,125,125,0.04)" },
  };

  const tableBodyCell = {
    py: 1.5,
    px: 2,
    fontSize: "0.85rem",
    color: "var(--text-color)",
    borderBottom: "1px solid rgba(125,125,125,0.08)",
  };

  const dialogPaper = {
    borderRadius: "16px",
    backgroundColor: "var(--popupbody-color)",
    color: "var(--text-color)",
  };

  const dialogTitleStyle = {
    fontWeight: 700,
    py: 2.25,
    color: "var(--text-color)",
    backgroundColor: "var(--popupheader-color)",
    position: "relative",
  };

  const modernFieldStyle = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "var(--body-color-less)",
      borderRadius: "8px",
      "& fieldset": { borderColor: "rgba(125,125,125,0.2)" },
    },
    "& .MuiInputBase-input": { color: "var(--text-color)", fontSize: "0.88rem" },
  };

  // ── Feedback card helper ───────────────────────────────────────────────────
  const feedbackCardSx = {
    backgroundColor: "var(--body-color-less2)",
    borderRadius: "12px",
    border: "1px solid rgba(125,125,125,0.12)",
    p: 2,
    mt: 2,
  };

  // ── User card helper (blocked / follow) ───────────────────────────────────
  const userCardSx = {
    backgroundColor: "var(--body-color-less2)",
    borderRadius: "12px",
    border: "1px solid rgba(125,125,125,0.12)",
    p: 2,
    width: 280,
  };

  return (
    <>
      <P2PNavbar />
      <Box sx={pageWrapper}>

        {/* ── Hero Banner ─────────────────────────────────────────────────── */}
        <Box
          sx={{
            background: `linear-gradient(135deg, ${alpha(btncolor, 0.95)} 0%, ${alpha(btncolor, 0.75)} 100%)`,
            borderRadius: "16px",
            p: { xs: 2.5, md: 3.5 },
            mb: 3,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              backgroundColor: "rgba(255,255,255,0.18)",
              borderRadius: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <AccountCircleIcon sx={{ fontSize: 32, color: "#fff" }} />
          </Box>
          <Box>
            <Typography
              sx={{ color: "#fff", fontWeight: 700, fontSize: "1.7rem", lineHeight: 1.2 }}
            >
              My P2P Profile
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.88)", fontSize: "0.9rem", mt: 0.5 }}>
              Manage your profile, payment methods, feedback and contacts
            </Typography>
          </Box>
        </Box>

        {/* ── Profile Card ────────────────────────────────────────────────── */}
        <Box sx={mainCard}>

          {/* Profile Header */}
          <Box sx={profileHeader}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%" }}
            >
              {/* Left: Avatar + Nickname + Status */}
              <Stack direction="row" spacing={2} alignItems="center">
                <Box position="relative" display="inline-block">
                  <Avatar
                    src={userInfoApi.profileImageLink}
                    sx={{ width: 60, height: 60 }}
                    alt={userInfoApi.firstLetter || "U"}
                  />
                  <CircleIcon
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: 3,
                      fontSize: 16,
                      color: green[500],
                    }}
                  />
                </Box>

                <Box>
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="h6"
                      sx={{ mr: 1, color: "var(--text-color)", fontWeight: 700 }}
                    >
                      {userInfoApi.nickname}
                    </Typography>
                    <IconButton size="small" onClick={handleClickOpen}>
                      <EditIcon fontSize="small" sx={{ color: "var(--text-color)", opacity: 0.6 }} />
                    </IconButton>
                  </Box>
                  <Typography variant="body2" sx={{ color: "var(--text-color)", opacity: 0.65 }}>
                    <span style={{ color: green[500] }}>Online</span> | Joined on{" "}
                    {userDetails?.createdOn?.split(" ")[0]}
                  </Typography>
                </Box>
              </Stack>

              {/* Right: P2P Estimated Value */}
              <Box textAlign="right">
                <Typography
                  variant="subtitle2"
                  sx={{ color: "var(--text-color)", opacity: 0.6, fontSize: "0.78rem", fontWeight: 600 }}
                >
                  P2P Estimated Value (USD)
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ color: "var(--text-color)" }}
                >
                  ${userInfoApi?.estimatedValueInUSD || "0.00"}
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* Verifications Row */}
          <Box
            sx={{
              px: { xs: 2, md: 3 },
              py: 2,
              borderBottom: "1px solid rgba(125,125,125,0.15)",
            }}
          >
            <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1.5 }}>
              {[
                ["Email", userInfoApi.emailStatus],
                ["SMS", userInfoApi.mobileStatus],
                ["KYC", userInfoApi.kycStatus],
                ["Address", userInfoApi.addressStatus],
              ].map(([label, status]) => (
                <Box
                  key={label}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: "20px",
                    backgroundColor: status
                      ? alpha(btncolor, 0.1)
                      : "rgba(239,68,68,0.1)",
                    border: status
                      ? `1px solid ${alpha(btncolor, 0.25)}`
                      : "1px solid rgba(239,68,68,0.25)",
                  }}
                >
                  {status === true ? (
                    <CustomCircleCheck bgColor={btncolor} />
                  ) : (
                    <CancelIcon color="error" sx={{ fontSize: 16 }} />
                  )}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "var(--text-color)",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                    }}
                  >
                    {label}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>

          {/* Metrics Grid */}
          <Box sx={{ px: { xs: 2, md: 3 }, py: 2 }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr 1fr",
                  sm: "repeat(3, 1fr)",
                  md: "repeat(4, 1fr)",
                  lg: "repeat(5, 1fr)",
                },
                gap: 1.5,
              }}
            >
              {[
                {
                  title: "30d Trades",
                  value: `${userDetails?.trades30D || 0} Time(s)`,
                },
                {
                  title: "30d Completion Rate",
                  value: `${userDetails?.completionRates30D || 0}%`,
                },
                {
                  title: "Avg Release Time",
                  value: `${userDetails?.avgReleaseTime || 0} Minute(s)`,
                },
                {
                  title: "Avg Pay Time",
                  value: `${userDetails?.avgPayTime || 0} Minute(s)`,
                },
                {
                  title: "Positive Feedback",
                  value: `${poitiveFeedPercent.toFixed(2) || 0}% (${
                    userDetails?.positiveFeedback || 0
                  })`,
                  extra: (
                    <>
                      <Typography variant="body2" sx={{ color: "success.main", fontSize: "0.78rem" }}>
                        Positive: {userDetails?.positiveFeedback || 0}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "error.main", fontSize: "0.78rem" }}>
                        Negative: {userDetails?.negativeFeedback || 0}
                      </Typography>
                    </>
                  ),
                },
                {
                  title: "Registration Age",
                  value: `${userDetails?.registrationAge || 0} days ago`,
                },
                {
                  title: "First Trade Age",
                  value: `${userDetails?.firstTradeDate || 0} days ago`,
                },
                {
                  title: "30-day Trading Volume",
                  value: `${userDetails?.tradingVolInUSD30D?.toFixed(2) || 0} USD`,
                },
                {
                  title: "Total Trading Volume",
                  value: `${userDetails?.tradingVolInUSD?.toFixed(2) || 0} USD`,
                },
              ].map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    p: 2,
                    backgroundColor: "var(--body-color-less2)",
                    border: "1px solid rgba(125,125,125,0.12)",
                    borderRadius: "12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      color: "var(--text-color)",
                      opacity: 0.6,
                      fontWeight: 600,
                      mb: 0.5,
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      color: "var(--text-color)",
                      fontWeight: 700,
                    }}
                  >
                    {item.value}
                  </Typography>
                  {item.extra && <Box mt={0.5}>{item.extra}</Box>}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        {/* ── Tabs Card ───────────────────────────────────────────────────── */}
        <Box sx={mainCard}>
          <Box sx={tabsWrap}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant={isMobile ? "fullWidth" : "scrollable"}
              orientation={isMobile ? "vertical" : "horizontal"}
              scrollButtons={isMobile ? false : "auto"}
              allowScrollButtonsMobile
              textColor="inherit"
              sx={tabsSx}
            >
              <Tab label="P2P Payment Methods" />
              <Tab label="Feedback" />
              <Tab label="Blocked Users" />
              <Tab label="Follows" />
            </Tabs>
          </Box>

          {/* ── P2P Payment Methods Tab ─────────────────────────────────── */}
          {selectedTab === 0 && (
            <Box sx={{ p: { xs: 2, md: 3 } }}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems={{ xs: "start", md: "center" }}
                flexDirection={{ xs: "column", md: "row" }}
                gap={2}
              >
                <Box sx={{ maxWidth: { xs: "100%", md: "70%" } }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "var(--text-color)", fontWeight: 700, mb: 0.5 }}
                  >
                    P2P Payment Methods
                  </Typography>
                  <Typography sx={{ color: "var(--text-color)", opacity: 0.65, fontSize: "0.88rem" }}>
                    P2P payment methods: When you sell cryptocurrencies, the
                    payment method added will be displayed to buyer as options
                    to accept payment, please ensure that the account owner's
                    name is consistent with your verified name on{" "}
                    {brokerBasicInfo?.exchange}. You can add up to 5 payment
                    methods.
                  </Typography>
                </Box>

                <Box sx={{ flexShrink: 0 }}>
                  <ContainedButton
                    variant="contained"
                    disabled={paymentMethodsCount >= 5}
                    onClick={() => setPaymentCreateModal(true)}
                  >
                    + Add a Payment Method
                  </ContainedButton>
                  {paymentMethodsCount >= 5 && (
                    <Typography variant="body2" color="error" sx={{ mt: 0.5 }}>
                      You cannot add more than 5 payment methods!
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Payment Methods Card */}
              <Box
                sx={{
                  backgroundColor: "var(--body-color-less2)",
                  borderRadius: "12px",
                  border: "1px solid rgba(125,125,125,0.12)",
                  overflow: "hidden",
                  mt: 2,
                }}
              >
                {/* Count line */}
                <Box sx={{ p: 2, borderBottom: "1px solid rgba(125,125,125,0.12)" }}>
                  <Typography
                    sx={{ color: "var(--text-color)", fontWeight: 700, fontSize: "0.92rem" }}
                  >
                    Total Payment Methods Added:{" "}
                    {walletServicePaymentMethodList.length +
                      bankTransferPaymentMethodList.length}
                  </Typography>
                </Box>

                {/* Child Tabs */}
                <Box sx={tabsWrap}>
                  <Tabs
                    value={selectedChildTab}
                    onChange={handleChildTabChange}
                    variant={isMobile ? "fullWidth" : "scrollable"}
                    orientation={isMobile ? "vertical" : "horizontal"}
                    scrollButtons={isMobile ? false : "auto"}
                    allowScrollButtonsMobile
                    textColor="inherit"
                    sx={tabsSx}
                  >
                    <Tab
                      label={`Wallet Services (${walletServicePaymentMethodList.length})`}
                    />
                    <Tab
                      label={`Bank Transfer (${bankTransferPaymentMethodList.length})`}
                    />
                  </Tabs>
                </Box>

                {/* Wallet Services Tab */}
                {selectedChildTab === 0 && (
                  <Box>
                    {walletServicePaymentMethodList.length === 0 ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          py: 5,
                          gap: 1,
                        }}
                      >
                        <InboxOutlinedIcon
                          sx={{ fontSize: 40, color: "var(--text-color)", opacity: 0.3 }}
                        />
                        <Typography
                          sx={{ color: "var(--text-color)", opacity: 0.5, fontSize: "0.88rem" }}
                        >
                          No Wallet Services Payment Method Added!
                        </Typography>
                      </Box>
                    ) : (
                      <TableContainer sx={modernTableContainer}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={tableHeadCell}>Payment Provider Name</TableCell>
                              <TableCell sx={tableHeadCell}>Wallet ID</TableCell>
                              <TableCell sx={tableHeadCell}>Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {walletServicePaymentMethodList.map((method, index) => (
                              <TableRow key={index} sx={tableBodyRow}>
                                <TableCell sx={tableBodyCell}>
                                  {method.paymentProviderName}
                                </TableCell>
                                <TableCell sx={tableBodyCell}>{method.walletId}</TableCell>
                                <TableCell sx={tableBodyCell}>
                                  <ButtonGroup>
                                    <OutlinedButton
                                      variant="outlined"
                                      onClick={() =>
                                        handleOpenEditPaymentModal(
                                          method.pmDetailsId,
                                          index,
                                          "wallet_services"
                                        )
                                      }
                                    >
                                      Edit
                                    </OutlinedButton>
                                    <OutlinedButton
                                      variant="outlined"
                                      onClick={() =>
                                        deletePaymentMethod(
                                          method.pmDetailsId,
                                          "wallet_service"
                                        )
                                      }
                                      sx={{ ml: 1 }}
                                    >
                                      Delete
                                    </OutlinedButton>
                                  </ButtonGroup>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                )}

                {/* Bank Transfer Tab */}
                {selectedChildTab === 1 && (
                  <Box>
                    {bankTransferPaymentMethodList.length === 0 ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          py: 5,
                          gap: 1,
                        }}
                      >
                        <InboxOutlinedIcon
                          sx={{ fontSize: 40, color: "var(--text-color)", opacity: 0.3 }}
                        />
                        <Typography
                          sx={{ color: "var(--text-color)", opacity: 0.5, fontSize: "0.88rem" }}
                        >
                          No Bank Transfer Payment Method Added!
                        </Typography>
                      </Box>
                    ) : (
                      <TableContainer sx={modernTableContainer}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={tableHeadCell}>Account Holder's Name</TableCell>
                              <TableCell sx={tableHeadCell}>Bank Name</TableCell>
                              <TableCell sx={tableHeadCell}>Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {bankTransferPaymentMethodList.map((method, index) => (
                              <TableRow key={index} sx={tableBodyRow}>
                                <TableCell sx={tableBodyCell}>
                                  {method.accountHolderName}
                                </TableCell>
                                <TableCell sx={tableBodyCell}>{method.bankName}</TableCell>
                                <TableCell sx={tableBodyCell}>
                                  <ButtonGroup>
                                    <OutlinedButton
                                      variant="outlined"
                                      onClick={() =>
                                        handleOpenEditPaymentModal(
                                          method.pmDetailsId,
                                          index,
                                          "bank_transfer_services"
                                        )
                                      }
                                    >
                                      Edit
                                    </OutlinedButton>
                                    <OutlinedButton
                                      variant="outlined"
                                      onClick={() =>
                                        deletePaymentMethod(
                                          method.pmDetailsId,
                                          "bank_transfer"
                                        )
                                      }
                                      sx={{ ml: 1 }}
                                    >
                                      Delete
                                    </OutlinedButton>
                                  </ButtonGroup>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          )}

          {/* ── Feedback Tab ────────────────────────────────────────────── */}
          {selectedTab === 1 && (
            <Box sx={{ p: { xs: 2, md: 3 } }}>
              <Box sx={tabsWrap}>
                <Tabs
                  value={selectedFeedbackChildTab}
                  onChange={handleFeedbackChildTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  textColor="inherit"
                  sx={tabsSx}
                >
                  <Tab label={`All (${allFeedback.length})`} />
                  <Tab label={`Positive (${positiveFeedback.length})`} />
                  <Tab label={`Negative (${negativeFeedback.length})`} />
                </Tabs>
              </Box>

              {/* All feedback */}
              {selectedFeedbackChildTab === 0 && (
                <Box sx={{ pt: 1 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: "var(--text-color)", mt: 2, mb: 1 }}>
                    All Feedback
                  </Typography>
                  {allFeedback.length === 0 && (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 5, gap: 1 }}>
                      <InboxOutlinedIcon sx={{ fontSize: 40, color: "var(--text-color)", opacity: 0.3 }} />
                      <Typography sx={{ color: "var(--text-color)", opacity: 0.5, fontSize: "0.88rem" }}>No feedback yet</Typography>
                    </Box>
                  )}
                  {allFeedback.map((method, index) => (
                    <Box key={index} sx={feedbackCardSx}>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: method.feedbackStatus == 1 ? "success.main" : "error.main", fontWeight: 700, mb: 1 }}
                      >
                        {method.feedbackStatus == 1 ? "Positive" : "Negative"} Feedback
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        {method.feedbackStatus == 1 ? (
                          <ThumbUpIcon color="success" sx={{ fontSize: 18 }} />
                        ) : (
                          <ThumbDownIcon color="error" sx={{ fontSize: 18 }} />
                        )}
                        <Typography sx={{ color: "var(--text-color)", fontSize: "0.88rem" }}>
                          {method.profileName}: {method.feedbackMessage}{" "}
                          <span style={{ fontStyle: "italic", opacity: 0.55 }}>
                            {method.feedbakCreatedDate}
                          </span>
                        </Typography>
                      </Stack>
                    </Box>
                  ))}
                </Box>
              )}

              {/* Positive feedback */}
              {selectedFeedbackChildTab === 1 && (
                <Box sx={{ pt: 1 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: "var(--text-color)", mt: 2, mb: 1 }}>
                    Positive Feedback
                  </Typography>
                  {positiveFeedback.length === 0 && (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 5, gap: 1 }}>
                      <InboxOutlinedIcon sx={{ fontSize: 40, color: "var(--text-color)", opacity: 0.3 }} />
                      <Typography sx={{ color: "var(--text-color)", opacity: 0.5, fontSize: "0.88rem" }}>No positive feedback yet</Typography>
                    </Box>
                  )}
                  {positiveFeedback.map((method, index) => (
                    <Box key={index} sx={feedbackCardSx}>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: method.feedbackStatus == 1 ? "success.main" : "error.main", fontWeight: 700, mb: 1 }}
                      >
                        {method.feedbackStatus == 1 ? "Positive" : "Negative"} Feedback
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        {method.feedbackStatus == 1 ? (
                          <ThumbUpIcon color="success" sx={{ fontSize: 18 }} />
                        ) : (
                          <ThumbDownIcon color="error" sx={{ fontSize: 18 }} />
                        )}
                        <Typography sx={{ color: "var(--text-color)", fontSize: "0.88rem" }}>
                          {method.profileName}: {method.feedbackMessage}{" "}
                          <span style={{ fontStyle: "italic", opacity: 0.55 }}>
                            {method.feedbakCreatedDate}
                          </span>
                        </Typography>
                      </Stack>
                    </Box>
                  ))}
                </Box>
              )}

              {/* Negative feedback */}
              {selectedFeedbackChildTab === 2 && (
                <Box sx={{ pt: 1 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: "var(--text-color)", mt: 2, mb: 1 }}>
                    Negative Feedback
                  </Typography>
                  {negativeFeedback.length === 0 && (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 5, gap: 1 }}>
                      <InboxOutlinedIcon sx={{ fontSize: 40, color: "var(--text-color)", opacity: 0.3 }} />
                      <Typography sx={{ color: "var(--text-color)", opacity: 0.5, fontSize: "0.88rem" }}>No negative feedback yet</Typography>
                    </Box>
                  )}
                  {negativeFeedback.map((method, index) => (
                    <Box key={index} sx={feedbackCardSx}>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: method.feedbackStatus == 1 ? "success.main" : "error.main", fontWeight: 700, mb: 1 }}
                      >
                        {method.feedbackStatus == 1 ? "Positive" : "Negative"} Feedback
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        {method.feedbackStatus == 1 ? (
                          <ThumbUpIcon color="success" sx={{ fontSize: 18 }} />
                        ) : (
                          <ThumbDownIcon color="error" sx={{ fontSize: 18 }} />
                        )}
                        <Typography sx={{ color: "var(--text-color)", fontSize: "0.88rem" }}>
                          {method.profileName}: {method.feedbackMessage}{" "}
                          <span style={{ fontStyle: "italic", opacity: 0.55 }}>
                            {method.feedbakCreatedDate}
                          </span>
                        </Typography>
                      </Stack>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          )}

          {/* ── Blocked Users Tab ───────────────────────────────────────── */}
          {selectedTab === 2 && (
            <Box sx={{ p: { xs: 2, md: 3 } }}>
              {allBlockedUsers.length === 0 ? (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 5, gap: 1 }}>
                  <InboxOutlinedIcon sx={{ fontSize: 40, color: "var(--text-color)", opacity: 0.3 }} />
                  <Typography sx={{ color: "var(--text-color)", opacity: 0.5, fontSize: "0.88rem" }}>No blocked users</Typography>
                </Box>
              ) : (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                  {allBlockedUsers.map((user, index) => (
                    <Box key={index} sx={userCardSx}>
                      <Stack direction="row" alignItems="center" spacing={2} mb={1}>
                        <Avatar sx={{ bgcolor: alpha(btncolor, 0.2), color: btncolor, fontWeight: 700 }}>
                          {user.nickName.charAt(0)}
                        </Avatar>
                        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "var(--text-color)" }}>
                          {user.nickName}
                        </Typography>
                      </Stack>
                      <Typography
                        variant="body2"
                        sx={{ color: "var(--text-color)", opacity: 0.65, mb: 2, fontSize: "0.83rem" }}
                      >
                        {user.reason}
                      </Typography>
                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <OutlinedButton
                          variant="outlined"
                          onClick={() => handleUnBlockUsers(user.blockedUser, user.blockBy)}
                        >
                          Unblock
                        </OutlinedButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          )}

          {/* ── Follows Tab ─────────────────────────────────────────────── */}
          {selectedTab === 3 && (
            <Box sx={{ p: { xs: 2, md: 3 } }}>
              <Box sx={tabsWrap}>
                <Tabs
                  value={selectedFollowChildTab}
                  onChange={handleFollowChildTabChange}
                  variant={isMobile ? "fullWidth" : "scrollable"}
                  orientation={isMobile ? "vertical" : "horizontal"}
                  scrollButtons={isMobile ? false : "auto"}
                  allowScrollButtonsMobile
                  textColor="inherit"
                  sx={tabsSx}
                >
                  <Tab label={`Followers (${allMyFollowersUsers.length})`} />
                  <Tab label={`Following (${allMyFollowingUsers.length})`} />
                </Tabs>
              </Box>

              {/* Followers */}
              {selectedFollowChildTab === 0 && (
                <Box sx={{ pt: 2 }}>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ color: btncolor, mb: 2 }}
                  >
                    Followers
                  </Typography>
                  {allMyFollowersUsers.length === 0 ? (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 5, gap: 1 }}>
                      <InboxOutlinedIcon sx={{ fontSize: 40, color: "var(--text-color)", opacity: 0.3 }} />
                      <Typography sx={{ color: "var(--text-color)", opacity: 0.5, fontSize: "0.88rem" }}>No followers yet</Typography>
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                      {allMyFollowersUsers.map((user, index) => (
                        <Box key={index} sx={userCardSx}>
                          <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                            <Avatar sx={{ bgcolor: alpha(btncolor, 0.2), color: btncolor, fontWeight: 700 }}>
                              {user.followerNickName.charAt(0)}
                            </Avatar>
                            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "var(--text-color)" }}>
                              {user.followerNickName}
                            </Typography>
                          </Stack>
                          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <OutlinedButton
                              variant="outlined"
                              onClick={() =>
                                handleUnFollowUsers(user.followingUuid, user.followerUuid)
                              }
                            >
                              Unfollow
                            </OutlinedButton>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}

              {/* Following */}
              {selectedFollowChildTab === 1 && (
                <Box sx={{ pt: 2 }}>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ color: "var(--text-color)" }}
                  >
                    Following
                  </Typography>
                  {allMyFollowingUsers.length === 0 ? (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 5, gap: 1 }}>
                      <InboxOutlinedIcon sx={{ fontSize: 40, color: "var(--text-color)", opacity: 0.3 }} />
                      <Typography sx={{ color: "var(--text-color)", opacity: 0.5, fontSize: "0.88rem" }}>Not following anyone yet</Typography>
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
                      {allMyFollowingUsers.map((user, index) => (
                        <Box key={index} sx={userCardSx}>
                          <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                            <Avatar sx={{ bgcolor: alpha(btncolor, 0.2), color: btncolor, fontWeight: 700 }}>
                              {user.followingNickName.charAt(0)}
                            </Avatar>
                            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "var(--text-color)" }}>
                              {user.followingNickName}
                            </Typography>
                          </Stack>
                          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <OutlinedButton
                              variant="outlined"
                              onClick={() =>
                                handleUnFollowUsers(user.followingUuid, user.followerUuid)
                              }
                            >
                              Unfollow
                            </OutlinedButton>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          )}
        </Box>

        {/* ── Edit Payment Method Dialog ──────────────────────────────────── */}
        <Dialog
          open={paymentEditModal}
          onClose={() => handlePaymentEditDialogClose}
          fullWidth
          maxWidth="md"
          PaperProps={{ sx: dialogPaper }}
        >
          <DialogTitle sx={dialogTitleStyle}>
            {editPaymentMethod === "Wallet Services"
              ? "Update Wallet Payment Method"
              : "Update Bank Transfer Payment Method"}
            <IconButton
              size="small"
              onClick={() => setPaymentEditModal(false)}
              sx={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-color)" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            {editPaymentMethod === "Wallet Services" ? (
              <Grid container spacing={2} mt={1}>
                <Grid size={12}>
                  <TextField
                    label="Payment Provider Name"
                    name="payment_provider_name"
                    value={paymentProviderNameEdit}
                    onChange={(e) => setPaymentProviderNameEdit(e.target.value)}
                    fullWidth
                    required
                    error={submitted && !formValues?.payment_provider_name}
                    helperText={
                      submitted && !formValues?.payment_provider_name
                        ? "Required"
                        : ""
                    }
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                  <TextField
                    label="Phone Number"
                    name="phone_number"
                    value={phoneNumberEdit}
                    onChange={(e) => setPhoneNumberEdit(e.target.value)}
                    fullWidth
                    required
                    error={
                      submitted && !formValues?.phone_number?.match(/^\d{8,15}$/)
                    }
                    helperText={
                      submitted && !formValues?.phone_number?.match(/^\d{8,15}$/)
                        ? "Enter a valid phone number"
                        : ""
                    }
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                  <TextField
                    label="Wallet ID"
                    name="wallet_id"
                    value={walletIdEdit}
                    onChange={(e) => setWalletIdEdit(e.target.value)}
                    fullWidth
                    required
                    error={submitted && !walletIdEdit}
                    helperText={submitted && !walletIdEdit ? "Required" : ""}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                  <TextField
                    label="Email ID"
                    name="email_id"
                    value={emailIdEdit}
                    onChange={(e) => setEmailIdEdit(e.target.value)}
                    fullWidth
                    required
                    error={
                      submitted &&
                      !emailIdEdit?.match(
                        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                      )
                    }
                    helperText={
                      submitted &&
                      !emailIdEdit?.match(
                        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                      )
                        ? "Enter a valid email"
                        : ""
                    }
                    sx={modernFieldStyle}
                  />
                </Grid>
              </Grid>
            ) : (
              <Box component="form" noValidate>
                <Grid container spacing={2} mt={1}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                      label="Account Holder's Name"
                      fullWidth
                      {...register("accountHolder", {
                        required: "Required",
                        pattern: {
                          value: /^[A-Za-z\s]+$/,
                          message: "Only alphabets and spaces are allowed",
                        },
                        maxLength: {
                          value: 40,
                          message: "Maximum 40 characters allowed",
                        },
                      })}
                      error={!!errors.accountHolder}
                      helperText={errors.accountHolder?.message}
                      sx={modernFieldStyle}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                      label="IBAN / Account Number"
                      fullWidth
                      {...register("ibanNumber", {
                        required: "Required",
                        pattern: {
                          value: /^[a-zA-Z0-9\s]+$/,
                          message: "Letters and numbers are allowed",
                        },
                        maxLength: {
                          value: 40,
                          message: "Maximum 40 characters allowed",
                        },
                      })}
                      error={!!errors.ibanNumber}
                      helperText={errors.ibanNumber?.message}
                      sx={modernFieldStyle}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Account Type</InputLabel>
                      <Select
                        label="Account Type"
                        {...register("accountType", { required: "Required" })}
                        value={selectedAccountType}
                        onChange={(e) => setSelectedAccountType(e.target.value)}
                        sx={modernFieldStyle["& .MuiOutlinedInput-root"] ? {} : {}}
                      >
                        <MenuItem value="Personal Savings">Personal Savings</MenuItem>
                        <MenuItem value="Personal Checking">Personal Checking</MenuItem>
                        <MenuItem value="Business Savings">Business Savings</MenuItem>
                        <MenuItem value="Business Checking">Business Checking</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid size={{ xs: 6, md: 3 }}>
                    <FormControl fullWidth>
                      <InputLabel>Code Type</InputLabel>
                      <Select
                        label="Code Type"
                        {...register("codeType", { required: "Required" })}
                        value={selectedCodeType}
                        onChange={(e) => setSelectedCodeType(e.target.value)}
                      >
                        <MenuItem value="ROUTING NO">ROUTING NO</MenuItem>
                        <MenuItem value="IFSC CODE">IFSC CODE</MenuItem>
                        <MenuItem value="SWIFT CODE">SWIFT CODE</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid size={{ xs: 6, md: 3 }}>
                    <TextField
                      label="Enter Code"
                      fullWidth
                      {...register("additionalCode", {
                        validate: validateBankCode,
                      })}
                      error={!!errors.additionalCode}
                      helperText={errors.additionalCode?.message}
                      sx={modernFieldStyle}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                      label="Bank Name"
                      fullWidth
                      {...register("bankName", {
                        required: "Required",
                        pattern: {
                          value: /^[a-zA-Z0-9\s]+$/,
                          message: "Letters and numbers are allowed",
                        },
                        maxLength: {
                          value: 50,
                          message: "Maximum 50 characters allowed",
                        },
                      })}
                      error={!!errors.bankName}
                      helperText={errors.bankName?.message}
                      sx={modernFieldStyle}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                      label="Bank Address"
                      fullWidth
                      {...register("bankAddress", {
                        required: "Required",
                        pattern: {
                          value: /^[a-zA-Z0-9,\-\s\/]+$/,
                          message:
                            "Letters, numbers, commas, and hyphens are allowed",
                        },
                        maxLength: {
                          value: 200,
                          message: "Maximum 200 characters allowed",
                        },
                      })}
                      error={!!errors.bankAddress}
                      helperText={errors.bankAddress?.message}
                      sx={modernFieldStyle}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2.5 }}>
            <ContainedButton onClick={() => setPaymentEditModal(false)}>
              Cancel
            </ContainedButton>

            {editPaymentMethod === "Wallet Services" ? (
              <ContainedButton
                variant="contained"
                onClick={() => updateWalletDetails()}
              >
                Submit
              </ContainedButton>
            ) : (
              <ContainedButton
                variant="contained"
                onClick={() => updateBankDetails()}
              >
                Submit
              </ContainedButton>
            )}
          </DialogActions>
        </Dialog>

        {/* ── Add Payment Method Dialog ───────────────────────────────────── */}
        <Dialog
          open={paymentCreateModal}
          onClose={() => setPaymentCreateModal(false)}
          fullWidth
          maxWidth="md"
          PaperProps={{ sx: dialogPaper }}
        >
          <DialogTitle sx={dialogTitleStyle}>
            Add Payment Method
            <IconButton
              size="small"
              onClick={() => setPaymentCreateModal(false)}
              sx={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-color)" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ mt: 1 }}>
              <FormControl fullWidth>
                <InputLabel>Choose Payment Method</InputLabel>
                <Select
                  label="Choose Payment Method"
                  value={selectedAccountType}
                  onChange={(e) => handleSelectBank(e.target.value)}
                  sx={modernFieldStyle["& .MuiOutlinedInput-root"] ? {} : {}}
                >
                  <MenuItem value="Wallet Services">Wallet Services</MenuItem>
                  <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                </Select>
              </FormControl>
            </Box>
            {createPaymentMethod === "Wallet Services" ? (
              <Grid container spacing={2} mt={1}>
                <Grid size={12}>
                  <TextField
                    label="Payment Provider Name"
                    name="payment_provider_name"
                    value={paymentProviderNameCreate}
                    onChange={(e) => setPaymentProviderNameCreate(e.target.value)}
                    fullWidth
                    required
                    error={submitted && !formValues?.payment_provider_name}
                    helperText={
                      submitted && !formValues?.payment_provider_name
                        ? "Required"
                        : ""
                    }
                    onKeyDown={allowOnlyAlphabets}
                    onPaste={handlePasteOnlyAlpha}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={4}>
                  <TextField
                    label="Phone Number"
                    name="phone_number"
                    value={phoneNumberCreate}
                    onChange={(e) => setPhoneNumberCreate(e.target.value)}
                    fullWidth
                    required
                    error={
                      submitted && !formValues?.phone_number?.match(/^\d{8,15}$/)
                    }
                    helperText={
                      submitted && !formValues?.phone_number?.match(/^\d{8,15}$/)
                        ? "Enter a valid phone number"
                        : ""
                    }
                    onKeyDown={allowPhoneNumber}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={4}>
                  <TextField
                    label="Wallet ID"
                    name="wallet_id"
                    value={walletIdCreate}
                    onChange={(e) => setWalletIdCreate(e.target.value)}
                    fullWidth
                    required
                    error={submitted && !walletIdEdit}
                    helperText={submitted && !walletIdEdit ? "Required" : ""}
                    onKeyDown={allowOnlyAlphaNum}
                    onPaste={handlePaste}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={4}>
                  <TextField
                    label="Email ID"
                    name="email_id"
                    value={emailIdCreate}
                    onChange={(e) => setEmailIdCreate(e.target.value)}
                    fullWidth
                    required
                    error={
                      submitted &&
                      !emailIdEdit?.match(
                        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                      )
                    }
                    helperText={
                      submitted &&
                      !emailIdEdit?.match(
                        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                      )
                        ? "Enter a valid email"
                        : ""
                    }
                    onKeyDown={allowEmail}
                    sx={modernFieldStyle}
                  />
                </Grid>
              </Grid>
            ) : createPaymentMethod === "Bank Transfer" ? (
              <Box component="form" noValidate>
                <Grid container spacing={2} mt={1}>
                  <Grid size={6}>
                    <TextField
                      label="Account Holder's Name"
                      fullWidth
                      value={userInfo.userResult.firstName}
                      disabled
                      error={!!errors.accountHolder}
                      helperText={errors.accountHolder?.message}
                      onKeyDown={allowOnlyAlphabets}
                      onPaste={handlePasteOnlyAlpha}
                      sx={modernFieldStyle}
                    />
                  </Grid>

                  <Grid size={6}>
                    <TextField
                      label="IBAN / Account Number"
                      fullWidth
                      {...register("ibanNumber", {
                        required: "Required",
                        pattern: {
                          value: /^[a-zA-Z0-9\s]+$/,
                          message: "Letters and numbers are allowed",
                        },
                        maxLength: {
                          value: 40,
                          message: "Maximum 40 characters allowed",
                        },
                      })}
                      error={!!errors.ibanNumber}
                      helperText={errors.ibanNumber?.message}
                      onKeyDown={allowOnlyAlphaNum}
                      onPaste={handlePaste}
                      sx={modernFieldStyle}
                    />
                  </Grid>

                  <Grid size={6}>
                    <FormControl fullWidth>
                      <InputLabel>Account Type</InputLabel>
                      <Select
                        label="Account Type"
                        {...register("accountType", { required: "Required" })}
                        value={selectedAccountType}
                        onChange={(e) => setSelectedAccountType(e.target.value)}
                      >
                        <MenuItem value="Personal Savings">Personal Savings</MenuItem>
                        <MenuItem value="Personal Checking">Personal Checking</MenuItem>
                        <MenuItem value="Business Savings">Business Savings</MenuItem>
                        <MenuItem value="Business Checking">Business Checking</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid size={3}>
                    <FormControl fullWidth>
                      <InputLabel>Code Type</InputLabel>
                      <Select
                        label="Code Type"
                        {...register("codeType", { required: "Required" })}
                        value={selectedCodeType}
                        onChange={(e) => setSelectedCodeType(e.target.value)}
                      >
                        <MenuItem value="ROUTING NO">ROUTING NO</MenuItem>
                        <MenuItem value="IFSC CODE">IFSC CODE</MenuItem>
                        <MenuItem value="SWIFT CODE">SWIFT CODE</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid size={3}>
                    <TextField
                      label="Enter Code"
                      fullWidth
                      {...register("additionalCode", {
                        validate: validateBankCode,
                      })}
                      error={!!errors.additionalCode}
                      helperText={errors.additionalCode?.message}
                      sx={modernFieldStyle}
                    />
                  </Grid>

                  <Grid size={6}>
                    <TextField
                      label="Bank Name"
                      fullWidth
                      {...register("bankName", {
                        required: "Required",
                        pattern: {
                          value: /^[a-zA-Z0-9\s]+$/,
                          message: "Letters and numbers are allowed",
                        },
                        maxLength: {
                          value: 50,
                          message: "Maximum 50 characters allowed",
                        },
                      })}
                      error={!!errors.bankName}
                      helperText={errors.bankName?.message}
                      onKeyDown={allowOnlyAlphabets}
                      onPaste={handlePasteOnlyAlpha}
                      sx={modernFieldStyle}
                    />
                  </Grid>

                  <Grid size={6}>
                    <TextField
                      label="Bank Address"
                      fullWidth
                      {...register("bankAddress", {
                        required: "Required",
                        pattern: {
                          value: /^[a-zA-Z0-9,\-\s\/]+$/,
                          message:
                            "Letters, numbers, commas, and hyphens are allowed",
                        },
                        maxLength: {
                          value: 200,
                          message: "Maximum 200 characters allowed",
                        },
                      })}
                      error={!!errors.bankAddress}
                      helperText={errors.bankAddress?.message}
                      onKeyDown={allowOnlyAlphabets}
                      onPaste={handlePasteOnlyAlpha}
                      sx={modernFieldStyle}
                    />
                  </Grid>
                </Grid>
              </Box>
            ) : (
              ""
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2.5 }}>
            <ContainedButton onClick={() => setPaymentCreateModal(false)}>
              Cancel
            </ContainedButton>

            {createPaymentMethod === "Wallet Services" ? (
              <ContainedButton
                variant="contained"
                onClick={() => createWalletDetails()}
              >
                Submit
              </ContainedButton>
            ) : (
              <ContainedButton
                variant="contained"
                onClick={() => createBankDetails()}
              >
                Submit
              </ContainedButton>
            )}
          </DialogActions>
        </Dialog>

        {/* ── Block Dialog ────────────────────────────────────────────────── */}
        <Dialog
          open={blockModalOpen}
          onClose={(e) => setBlockModalOpen(false)}
          PaperProps={{ sx: dialogPaper }}
        >
          <DialogTitle sx={dialogTitleStyle}>
            Block User
            <IconButton
              size="small"
              onClick={() => setBlockModalOpen(false)}
              sx={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-color)" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <FormControl>
              <RadioGroup
                value={selectedReason}
                onChange={(e) => {
                  setSelectedReason(e.target.value);
                  setOtherReasonStatus(e.target.value === "other");
                }}
              >
                {allBlockReason.map((block) => (
                  <FormControlLabel
                    key={block.id}
                    value={block.id.toString()}
                    control={<Radio />}
                    label={block.reason}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            {otherReasonStatus && (
              <TextField
                multiline
                rows={3}
                fullWidth
                placeholder="Please tell us the reason for blocking the user"
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                style={{ marginTop: 10 }}
                sx={modernFieldStyle}
              />
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5 }}>
            <ContainedButton
              variant="contained"
              onClick={(e) => blockUnblockApiCall(1, selectedReason)}
              style={{ marginTop: 16 }}
              disabled={!selectedReason}
            >
              Block
            </ContainedButton>
          </DialogActions>
        </Dialog>

        {/* ── Change Nickname Dialog ──────────────────────────────────────── */}
        <Dialog
          open={openNicknameModal}
          onClose={handleClose}
          PaperProps={{ sx: dialogPaper }}
        >
          <DialogTitle sx={dialogTitleStyle}>
            Change Nickname
            <IconButton
              size="small"
              onClick={handleClose}
              sx={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-color)" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Set Nickname"
              fullWidth
              value={userInfoApi.nickname}
              helperText="It is recommended not to use your real name. Nickname can only be modified once every 180 days."
              onChange={(e) => {
                setUserInfo((prev) => ({
                  ...prev,
                  nickname: e.target.value,
                }));
              }}
              sx={modernFieldStyle}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5 }}>
            <ContainedButton onClick={handleClose} color="inherit">
              Cancel
            </ContainedButton>
            <ContainedButton onClick={handleSave} variant="contained">
              Save
            </ContainedButton>
          </DialogActions>
        </Dialog>

      </Box>
    </>
  );
};

export default P2PMyProfile;
